import React from 'react'

import MoviePage from 'components/MoviePage'


export const App = () => {
  return <MoviePage />
}
